/* eslint-disable */
import { Component } from "react";
import { getEnums, updateEnums } from "../../utils/store/actions/survey.action";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { connectModal } from "redux-modal";
import IconButton from "@material-ui/core/IconButton";
import CancelIcon from "@material-ui/icons/Cancel";
import { Card, CardContent } from "@material-ui/core";
import PersonIcon from "@material-ui/icons/Person";
import BusinessIcon from "@material-ui/icons/Business";

import {
  getAllIssuerSigners,
  getAllProductSigners,
  createPersonSigner,
  updatePersonSigner,
  getFund,
} from "../../utils/store/actions/funds.actions";
import { Button } from "@material-ui/core";
import { B4FText } from "../component-questionnaire/B4FFields/B4FText";
import { B4FEmail } from "../component-questionnaire/B4FFields/B4FEmail";
import PhoneNumberInput from "../component-questionnaire/B4FFields/PhoneNumberInput/PhoneNumberInput";
import { B4FSelect } from "../component-questionnaire/B4FFields/B4FSelect";
import { B4FRadio } from "../component-questionnaire/B4FFields/B4FRadio";
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";

const styles = (theme: Theme) =>
  createStyles({
    fundCards: {
      borderRadius: "12px",
      margin: "0 auto",
      display: "grid",
      gridGap: "1rem",
      gridTemplateColumns: "repeat(2, 2fr)",
      [theme.breakpoints.up("lg")]: {
        gridTemplateColumns: "repeat(2, 2fr)",
      },
      [theme.breakpoints.up("xl")]: {
        gridTemplateColumns: "repeat(2, 2fr)",
      },
    },
    card: {
      borderRadius: "12px",
      margin: "1%",
      border: "1px solid #EAEDF7",
      boxShadow:
        "0px 0px 1px rgba(44, 44, 44, 0.1), 0px 30px 40px rgba(175, 175, 175, 0.08)",
    },
  });
class ModalFundAddUpdateSigners extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      signerType: this.props.signerType,
      signer: {
        id: "",
        name: "",
        firstName: "",
        email: "",
        personType: "",
        phone: "",
        roleFunction: "",
        status: "",
        legalForm: "SOCIETE_PRIVEE_A_RESPONSABILITE_LIMITEE_STARTER",
        defaultSigner: false,
        countryCorporation: "",
        visibleOperations: ['DISTRIBUTION_AGREEMENT', 'SUBSCRIPTION'],
      },
    };
  }
  componentDidMount() {
    if (this.props.actionDone === "CREATE") {
      this.setState({
        signerType: this.props.signerType,
        signer: {
          id: "",
          name: "",
          firstName: "",
          email: "",
          personType: "INDIVIDUAL",
          phone: "",
          roleFunction: "",
          status: "",
          legalForm: "SOCIETE_PRIVEE_A_RESPONSABILITE_LIMITEE_STARTER",
          defaultSigner: false,
          countryCorporation: "",
          visibleOperations:  ['DISTRIBUTION_AGREEMENT', 'SUBSCRIPTION'],

        },
      });
    } else if (this.props.actionDone === "UPDATE") {
      this.setState({
        signer:
          this.props.signer.personType === "COMPANY"
            ? {
                ...this.props.signer,
                countryCorporation: this.props.Funds.person.countryCorporation,
              }
            : this.props.signer,
        signerType: this.props.signerType,
      });
    }
    this.props.getEnums();
  }
  handleAddSigner = () => {
    this.props
      .createPersonSigner(this.state.signer, this.state.signerType)
      .then(() => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const fundPersonId = urlParams.get("id");
        this.props.getAllIssuerSigners(fundPersonId);
        this.props.getAllProductSigners(fundPersonId);
        this.setState({
          signerType: "",
          signer: {
            id: "",
            name: "",
            firstName: "",
            email: "",
            personType: "",
            phone: "",
            roleFunction: "",
            status: "",
            legalForm: "SOCIETE_PRIVEE_A_RESPONSABILITE_LIMITEE_STARTER",
            defaultSigner: false,
            visibleOperations: ['DISTRIBUTION_AGREEMENT', 'SUBSCRIPTION'],
          },
        });
      });
  };

  handleChange = (value: string, operation: string) => {
    let updatedvisibleOperations = [...this.state.signer.visibleOperations];
    if (value === "true") {
      if (!updatedvisibleOperations.includes(operation)) {
        updatedvisibleOperations.push(operation);
      }
    } else {
      updatedvisibleOperations = updatedvisibleOperations.filter(op => op !== operation);
    }
    this.setState({
      signer: {
        ...this.state.signer,
        visibleOperations: updatedvisibleOperations,
      },
    });
  }

  updatePersonSigner = () => {
    this.props
      .updatePersonSigner(
        this.props.signer.id,
        this.state.signer,
        this.state.signerType
      )
      .then(() => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const fundPersonId = urlParams.get("id");
        this.props.getFund();
        this.props.getAllIssuerSigners(fundPersonId);
        this.props.getAllProductSigners(fundPersonId);
      });
  };

  render() {
    const { show, handleHide, Surveys, t, classes } = this.props;
    const closeBtn = (
      <IconButton className="close" onClick={handleHide}>
        <CancelIcon />
      </IconButton>
    );
    return (
      <Modal
        isOpen={show}
        toggle={handleHide}
        backdrop={true}
        style={{
          backgroundColor: "#f5f6ff",
          width: "90%",
          top: "20%",
          maxWidth: "90%",
          maxHeight: "98%",
        }}
      >
        <ModalHeader
          toggle={handleHide}
          close={closeBtn}
          style={{
            backgroundColor: "#f5f6ff",
            color: "black",
            fontWeight: "bolder",
            fontSize: "20px",
          }}
        >
          {this.props.signerType === "ISSUER"
            ? t("ISSUER")
            : t("PRODUCT_SIGNER")}
        </ModalHeader>
        <div
          style={{
            backgroundColor: "#f5f6ff",
            display: "flex",
            justifyContent: "space-evenly",
          }}
        >
          {" "}
          <PersonIcon
            onClick={() => {
              this.setState({
                signer: {
                  ...this.state.signer,
                  personType: "INDIVIDUAL",
                },
              });
            }}
            style={{
              fontSize: "80px",
              color:
                this.state.signer.personType === "INDIVIDUAL"
                  ? "#242F57"
                  : "#97A0C3",
            }}
          />
          <BusinessIcon
            onClick={() => {
              this.setState({
                signer: {
                  ...this.state.signer,
                  personType: "COMPANY",
                },
              });
            }}
            style={{
              fontSize: "80px",
              color:
                this.state.signer.personType === "COMPANY"
                  ? "#242F57"
                  : "#97A0C3",
            }}
          />
        </div>

        <ModalBody
          style={{
            backgroundColor: "#f5f6ff",
          }}
        >
          <div style={{ margin: "1%", fontWeight: "bolder" }}>
            {t("INFORMATIONS")[0].toUpperCase() +
              t("INFORMATIONS").slice(1).toLowerCase()}
          </div>
          <Card className={classes.card}>
            <CardContent className={classes.fundCards}>
              {this.state.signer.personType === "INDIVIDUAL" && (
                <>
                  <B4FText
                    label="FIRST_NAME"
                    value={this.state.signer.firstName}
                    id="contact_firstName"
                    key="hello"
                    onBlur={console.log}
                    placeholder=""
                    isRequired={true}
                    onChange={(e: any) => {
                      this.setState({
                        signer: {
                          ...this.state.signer,
                          firstName: e.value,
                        },
                      });
                    }}
                    visible={true}
                  />
                  <B4FText
                    label="LAST_NAME"
                    value={this.state.signer.name}
                    id="signerName"
                    key="signerName"
                    onBlur={console.log}
                    placeholder=""
                    onChange={(e: any) => {
                      this.setState({
                        signer: {
                          ...this.state.signer,
                          name: e.value,
                        },
                      });
                    }}
                    isRequired={true}
                    visible={true}
                  />
                  <B4FEmail
                    label="EMAIL"
                    value={this.state.signer.email}
                    onBlur={console.log}
                    onChange={(e: any) => {
                      this.setState({
                        signer: {
                          ...this.state.signer,
                          email: e.target.value,
                        },
                      });
                    }}
                    id="email"
                    key="email"
                    placeholder="contact@email.com"
                    isRequired={true}
                    isDisabled={false}
                    visible={true}
                  />
                  <PhoneNumberInput
                    value={this.state.signer.phone}
                    label="MOBILE"
                    onBlur={console.log}
                    onChange={(value: string) => {
                      this.setState({
                        signer: {
                          ...this.state.signer,
                          phone: value,
                        },
                      });
                    }}
                    id="phone"
                    key="phone"
                    isRequired={true}
                    visible={true}
                  />
                  <B4FText
                    label="FUNCTION"
                    value={this.state.signer.roleFunction}
                    id="roleFunction"
                    key="roleFunction"
                    onBlur={console.log}
                    onChange={(e: any) => {
                      this.setState({
                        signer: {
                          ...this.state.signer,
                          roleFunction: e.value,
                        },
                      });
                    }}
                    placeholder=""
                    isRequired={false}
                    visible={true}
                  />
                </>
              )}
              {this.state.signer.personType === "COMPANY" && (
                <>
                  <B4FText
                    label="LAST_NAME"
                    value={this.state.signer.name}
                    id="signerName"
                    key="signerName"
                    onBlur={console.log}
                    placeholder=""
                    onChange={(e: any) => {
                      this.setState({
                        signer: {
                          ...this.state.signer,
                          name: e.value,
                        },
                      });
                    }}
                    isRequired={true}
                    visible={true}
                  />
                  <B4FSelect
                    label="COUNTRY_OF_INCORPORATION"
                    value={this.state.signer.countryCorporation}
                    onBlur={console.log}
                    id="countryCorporation"
                    key="countryCorporation"
                    onChange={(e: any) => {
                      this.setState({
                        signer: {
                          ...this.state.signer,
                          countryCorporation: e.value,
                        },
                      });
                      this.props.updateEnums(e.value);
                    }}
                    options={Surveys?.enums["countries"]}
                    isRequired={true}
                    visible={true}
                  />
                  <B4FSelect
                    label="LEGAL_FORM"
                    value={this.state.signer.legalForm}
                    onBlur={console.log}
                    id="legalForm"
                    key="legalForm"
                    onChange={(e: any) => {
                      this.setState({
                        signer: {
                          ...this.state.signer,
                          legalForm: e.value,
                        },
                      });
                    }}
                    options={Surveys?.enums["legal-forms"]}
                    isRequired={true}
                    visible={true}
                  />
                </>
              )}
              <B4FRadio
                label="DEFAULT_SIGNER"
                key="defaultSigner"
                id="defaultSigner"
                onChange={(e: any) => {
                  this.setState({
                    signer: {
                      ...this.state.signer,
                      defaultSigner: e.target.value,
                    },
                  });
                }}
                options={[
                  { label: "YES_NO.YES", key: "true" },
                  { label: "YES_NO.NO", key: "false" },
                ]}
                value={this.state.signer.defaultSigner.toString()}
                isRequired={true}
                visible={true}
              />
              <>
                <B4FRadio
                    label="IS_COSIGNER_VISIBLE_FOR_CONVENTION"
                    key="signerIsVisibleForConvention"
                    id="signerIsVisibleForConvention"
                    onChange={(e: any) => this.handleChange(e.target.value, "DISTRIBUTION_AGREEMENT")}
                    options={[
                      { label: "YES_NO.YES", key: "true" },
                      { label: "YES_NO.NO", key: "false" },
                    ]}
                    value={this.state.signer.visibleOperations?.includes("DISTRIBUTION_AGREEMENT") ? "true" : "false"}
                    isRequired={true}
                    visible={this.props.signerType === "ISSUER"}
                />
                <B4FRadio
                    label="IS_COSIGNER_VISIBLE_FOR_SUBSCRIPTION"
                    key="signerIsVisibleForSubscription"
                    id="signerIsVisibleForSubscription"
                    onChange={(e: any) => this.handleChange(e.target.value, "SUBSCRIPTION")}
                    options={[
                      { label: "YES_NO.YES", key: "true" },
                      { label: "YES_NO.NO", key: "false" },
                    ]}
                    value={this.state.signer.visibleOperations?.includes("SUBSCRIPTION") ? "true" : "false"}
                    isRequired={true}
                    visible={this.props.signerType === "ISSUER"}
                />
              </>
            </CardContent>
          </Card>
        </ModalBody>
        {this.props.actionDone === "CREATE" && (
          <ModalFooter
            style={{
              backgroundColor: "#f5f6ff",
              borderRadius: "10px",
            }}
          >
            <Button
              variant="contained"
              style={{
                color: "white",
                backgroundColor: "#ae0064",
                textTransform: "none",
              }}
              onClick={() => {
                this.handleAddSigner(), handleHide();
              }}
              disabled={
                this.state.personType === "INDIVIDUAL"
                  ? this.state.name === "" ||
                    this.state.signerType === "" ||
                    this.state.personType === "" ||
                    this.state.defaultSigner === "" ||
                    this.state.firstName === ""
                  : this.state.signerType === "" ||
                    this.state.personType === "" ||
                    this.state.defaultSigner === "" ||
                    this.state.name === "" ||
                    this.state.legalForm === ""
              }
            >
              {t("ADD")}
            </Button>
          </ModalFooter>
        )}
        {this.props.actionDone === "UPDATE" && (
          <ModalFooter
            style={{
              backgroundColor: "#f5f6ff",
              borderRadius: "10px",
            }}
          >
            <Button
              variant="contained"
              style={{
                color: "white",
                backgroundColor: "#ae0064",
                textTransform: "none",
              }}
              onClick={() => {
                this.updatePersonSigner(), handleHide();
              }}
              disabled={
                this.state.personType === "INDIVIDUAL"
                  ? this.state.name === "" ||
                    this.state.personType === "" ||
                    this.state.defaultSigner === "" ||
                    this.state.firstName === ""
                  : this.state.personType === "" ||
                    this.state.defaultSigner === "" ||
                    this.state.name === "" ||
                    this.state.legalForm === ""
              }
            >
              {t("UPDATE")}
            </Button>
          </ModalFooter>
        )}
      </Modal>
    );
  }
}
const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getAllIssuerSigners,
  getAllProductSigners,
  getEnums,
  createPersonSigner,
  updatePersonSigner,
  getFund,
  updateEnums,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withTranslation()(
    withStyles(styles)(
      connectModal({ name: "create_update_signer" })(ModalFundAddUpdateSigners)
    )
  )
);
